// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import React from 'react'
import { array, bool, object, oneOfType, string } from 'prop-types'
import UpdatedInputBase from '../UpdatedInputBase'
import { UpdatedSelectDynamicWrapper } from './styles'

import {
  ErrorSimple,
  LabelSimple,
  LookupWrapper,
} from 'components/Form'

class UpdatedSelectDynamic extends UpdatedInputBase {
  static propTypes = {
    emptyOptionLabel: string,
    disabled: bool,
    id: string.isRequired,
    input: object.isRequired,
    label: oneOfType([
      string,
      object,
    ]),
    labelKey: string.isRequired,
    lookup: oneOfType([
      string,
      object,
    ]),
    meta: object.isRequired,
    options: oneOfType([
      array.isRequired,
      object.isRequired,
    ]),
    valueKey: string.isRequired,
  }

  static defaultProps = {
    className: '',
    lookup: null,
  }

  // assemble the list of options from native JS objects
  arrayOptions = () => {
    const {
      labelKey,
      options,
      valueKey,
    } = this.props

    return options.map(d => (
      <option
        key={`${valueKey}-${d[valueKey]}`}
        title={d[labelKey]}
        value={d[valueKey]}>
        {d[labelKey]}
      </option>
    ))
  }

  // TODO - clean this up. Since updated, it is no longer
  // assumed what the

  // assemble the list of options from immutable.js Maps
  immutableOptions = () => {
    const {
      labelKey,
      options,
      valueKey,
    } = this.props

    return options.map(d => (
      <option
        key={`${valueKey}-${d.get(valueKey)}`}
        title={d.get(labelKey)}
        value={d.get(valueKey)}>
        {d.get(labelKey)}
      </option>
    ))
  }

  // dynamically build the options for this
  options = () => (
    Array.isArray(this.props.options)
      ? this.arrayOptions()
      : this.immutableOptions()
  )

  render () {
    const {
      className,
      disabled,
      emptyOptionLabel,
      id,
      input,
      label,
      lookup,
      meta: { error },
    } = this.props

    // if the element is disabled, and it has no assigned value, it would
    // show its null label, eg. "-Select Option-"
    // since this is confusing as readonly text,
    // just give the thing opacity so it doesn't show.
    const disabledClass = (
      disabled && !input.value
        ? 'opacity-0'
        : ''
    )

    return (
      <UpdatedSelectDynamicWrapper className={`updated-select-dynamic ${className}`}>
        <LabelSimple
          idRoot={id}
          label={label} />
        <select
          id={id}
          {...input}
          className={`select ${disabledClass}`}
          disabled={disabled}
          onBlur={this.handleBlur}
          onChange={this.handleChange}>
          {
            emptyOptionLabel
              ? <option value={''}>{emptyOptionLabel}</option>
              : null
          }
          {this.options()}
        </select>
        <LookupWrapper
          lookup={lookup} />
        <ErrorSimple
          error={error}
          idRoot={id} />
      </UpdatedSelectDynamicWrapper>
    )
  }
}

export default UpdatedSelectDynamic
